import React from 'react';
import teamPhoto from '../assets/images/team.png';
import logo from '../assets/images/LOGO.png';

const TeamSection = () => {
    return (
        <section id="career" className="bg-white overflow-hidden">
            <div className="flex flex-col lg:flex-row min-h-[400px] md:min-h-[500px]">
                {/* Left Side Branding - Dark Blue */}
                <div className="lg:w-[40%] bg-[#002147] p-8 md:p-20 flex flex-col justify-center items-center text-center">
                    <div className="bg-white p-1 shadow-lg mb-8 md:mb-10 inline-block">
                        <img src={logo} alt="DBQ Logo" className="h-10 w-10 md:h-14 md:w-14 object-contain" />
                    </div>

                    <h2 className="text-white text-4xl md:text-6xl font-bold mb-6 md:mb-8 tracking-[0.1em] uppercase">
                        Our Team
                    </h2>

                    <p className="text-white text-xs md:text-base tracking-[0.1em] md:tracking-[0.2em] font-light uppercase border-t border-white/20 pt-6 md:pt-8 max-w-[200px] md:max-w-xs mx-auto">
                        Looking forward to get connect with you.
                    </p>
                </div>

                {/* Right Side Team Photo */}
                <div className="lg:w-[60%] relative min-h-[300px] md:min-h-[400px]">
                    <img
                        src={teamPhoto}
                        alt="DBQ Team"
                        className="absolute inset-0 w-full h-full object-cover"
                    />
                </div>
            </div>
        </section>
    );
};

export default TeamSection;

